import axios from 'axios';

export default {
  state: {
    orders: [],
    section: {},
    ordersLoading: false,
    ordersError: null,
    ordersLoaded: false,
    noMoreOrders: false
  },
  mutations: {
    SET_ORDERS(state, {orders, page}) {
      if (page > 1) {
        state.orders = state.orders.concat(orders.data.items)
      }
      else
        state.orders = orders.data.items;
      if (state.orders.length >= orders.data.total)
        state.noMoreOrders = true;
      state.ordersLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_ORDERS_LOADING(state, status) {
      state.ordersLoading = status;
    },
    SET_ORDERS_ERROR(state, error) {
      state.ordersError = error;
    },
    UNSET_ORDERS(state) {
      state.ordersLoaded = false;
      state.ordersLoading = false;
      state.orders = [];
      state.noMoreOrders = false;
    },
  },
  actions: {
    async fetchOrders({ commit, state }, {page, finish}) {
      if (page == 1)
        commit('UNSET_ORDERS');

      try {
        commit('SET_ORDERS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/order/', {
          params: {
            page: page,
            finish: finish
          }
        });
        commit('SET_ORDERS', {orders:response.data, page:page});
        commit('SET_ORDERS_ERROR', null);
      } catch (error) {
        commit('SET_ORDERS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching orders:', error);
      } finally {
        commit('SET_ORDERS_LOADING', false);
      }
    }
  },
  getters: {
    orders: state => state.orders,
    ordersLoading: state => state.ordersLoading,
    ordersError: state => state.ordersError,
    ordersLoaded: state => state.ordersLoaded,
    noMoreOrders: state => state.noMoreOrders
  }
}